import { NgModule } from '@angular/core';
import { FavoritesComponent } from './favorites.component';
import { SharedModule } from '../shared/shared.module';
import { CookieService } from 'ngx-cookie-service';
import { FavoritesService } from './favorites.service';

@NgModule({
  declarations: [
    FavoritesComponent
  ],
  exports: [
    FavoritesComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    CookieService,
    FavoritesService
  ]
})

export class FavoritesModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/leolux-dealer-outlet-frontend/checkout/src/app/components/favorites/favorites.module.ts